import styled from 'styled-components'
import { OrangeColor, GrayColor, White } from '../../constants/constants'
import { Update } from 'styled-icons/material-outlined'
import { CopyAlt } from '@styled-icons/boxicons-regular/CopyAlt'

export const ProfileWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${White};
  padding-bottom: 20px;
  width: 100%;
  @media (max-width: 600px) {
    height: auto;
  }
  height: auto;
  margin: 0px auto;
  margin-bottom: 20px;
`
export const CompanyProfile = styled.div`
  margin-top: 20px;
  font-size: 10pt;
  color: ${GrayColor};
  font-weight: bold;
`

export const HeaderProfileWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 50px;
  margin-bottom: -25px;
`

export const SubtitlesWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`

export const EmployeeName = styled.div`
  display: flex;
  flex-direction: row;
  font-weight: bold;
  color: ${OrangeColor};
  font-size: 20pt;
`

export const RoleDegree = styled.div`
  display: flex;
  flex-direction: row;
  font-size: 16pt;
  margin-top: 15px;
`

export const SinceDate = styled.div`
  display: flex;
  flex-direction: row;
  font-size: 12pt;
  margin-top: 0px;
`

export const Line = styled.hr`
  margin-top: 40px;
  margin-bottom: 50px;
  border: 1px solid ${OrangeColor};
  background-color: ${OrangeColor};
  width: 100%;
  margin-left: 0px;
`

export const InfoWrapper = styled.div`
  display: flex;
  @media (max-width: 600px) {
    flex-direction: column-reverse;
  }
  flex-direction: row;
  width: 100%;
  flex-basis: 100%;
  flex: 1;
`

export const InfoColum1 = styled.div`
  height: auto;
  @media (max-width: 600px) {
    width: 100%;
  }
  width: 40%;
`
export const InfoColum2 = styled.div`
  height: auto;
  @media (max-width: 600px) {
    width: 100%;
  }
  width: 60%;
`

export const BoldText = styled.div`
  font-weight: bold;
  color: ${(props) => (props.color ? props.color : 'black')};
  margin-bottom: 25px;
`

export const ProfessionalExperienceTitle = styled.div`
  font-weight: bold;
  color: ${GrayColor};
  margin-top: 70px;
`

export const ActionContainer = styled.div`
  margin-top: 50px;
  display: flex;
`
export const SectionTitle = styled.div`
  font-size: 28px;
  font-weight: 600;
  padding-top: 30px;

  padding-bottom: 30px;
`
export const SectionLastUpdate = styled.div`
  font-size: 10pt;
  color: ${GrayColor};
  font-weight: bold;
`
export const ProfileActionButton = styled.button`
  margin-left: 5px;
  margin-right: 5px;
  margin-top: 12px;
  display: block;
  height: fit-content;
  border: 1px solid ${OrangeColor};
  padding: 3px 8px;
  border-radius: 10px;
  background: unset;
  cursor: pointer;
  position: relative;
`

export const UpdateProfileButtonLabel = styled.span`
  color: ${OrangeColor};
  line-height: 1;
`

export const UpdateProfileButtonIcon = styled(Update)`
  color: ${OrangeColor};
  margin-right: 8px;
`

export const CopyProfileButtonIcon = styled(CopyAlt)`
  color: ${OrangeColor};
`

export const Profile = styled.div`
  display: flex;
  justify-content: space-between;
`
export const ImageContainer = styled.div`
  margin-left: 20px;
`
